import React from 'react'

const AppStudioGraphContainer = ({ header, Component }) => {
  return (
    <div className='flex flex-col bg-white  rounded-lg overflow-hidden border  h-full'>
      <div className='bg-[#EDF0F2] px-2 py-3 font-semibold rounded-t-lg text-sm border-b'>{header}</div>
      <div className=' h-full'>
        <Component />
      </div>
    </div>
  )
}

export default AppStudioGraphContainer